export default __webpack_public_path__ + "static/media/kingoftheweb-badge-sm.146383d8.svg";